export default {
	data() {
		return {
			screenInfo: {}
		};
	},
	computed: {
		getSreenInfo() {
			return this.screenInfo;
		}
	},

	created() {
		const me = this;
		me.updateSizeSreen();
	},
	methods: {
		updateSizeSreen() {
			const me = this;
			me.screenInfo = me.$ms.commonFunc.getScreenInfo();
			me.screenInfo.isSmallScreen = me.$ms.commonFunc.checkSmallScreen();
		}
	},
	mounted() {
		window.addEventListener('resize', this.updateSizeSreen);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updateSizeSreen);
	}
};
